/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum FuelSurcharge {
    DoNotCalculateFSC = 78,
    UseTariffIfNoCustomerFSCRates = 89,
    UseCustomerFSCRates = 84,
}
